module.exports = __webpack_public_path__ + "static/media/competitionBG.ed35682a.png";